var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-column"},[_c('div',{staticClass:"title has-text-centered"},[_vm._v("\n    "+_vm._s(_vm.contents.name)+"\n  ")]),_vm._v(" "),_c('img',{staticClass:"profile",attrs:{"src":_vm.contents.image}}),_vm._v(" "),_c('vue-markdown',{staticClass:"content has-text-centered",attrs:{"source":_vm.contents.shortcontact}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239a319a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavColumn.vue
// module id = 204
// module chunks = 1